import React from "react";
import { Modal, InputNumber, Divider, Input, Checkbox } from "antd";
import { withNamespaces } from "react-i18next";

function PrintCountModal({
  visible,
  onPrint,
  onCancel,
  direction,
  t,
  handlePropsChange,
  values,
  type = "thermal",
}) {
  const [count, setCount] = React.useState(null);

  return (
    <Modal
      title={
        <div
          className="ant-modal-title"
          style={{
            textAlign: direction == "rtl" ? "right" : "left",
          }}
        >
          {t("Enter a number of copies")}
        </div>
      }
      visible={visible}
      width={300}
      onOk={() => onPrint(count)}
      onCancel={onCancel}
      bodyStyle={{
        paddingInline: 8,
        textAlign: direction == "rtl" ? "right" : "left",
      }}
      okButtonProps={{
        disabled:
          (type == "thermal" &&
            (count <= 0 || count == null || Number.isNaN(parseInt(count)))) ||
          (values.qr_code_insta && (!values.insta || values.insta == "")),
      }}
      okText={t("Print")}
    >
      {type == "thermal" && (
        <>
          <div
            style={{
              gap: 8,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              paddingInline: 8,
            }}
          >
            <span>{t("How many do you want?")}</span>
            <InputNumber
              style={{ width: "100%" }}
              onChange={(val) => setCount(val)}
            />
          </div>
          <Divider />
        </>
      )}

      <div
        style={{
          gap: 8,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          paddingInline: 8,
        }}
      >
        {t("Optional Additions:")}
        <span>{t("Phone")} </span>
        <Input onChange={(e) => handlePropsChange("phone", e.target.value)} />
        <span>{t("Address")} </span>
        <Input onChange={(e) => handlePropsChange("address", e.target.value)} />
        <span>
          {t("Instagram")}
          {values.qr_code_insta && <span style={{ color: "red" }}>*</span>}
        </span>
        <Input onChange={(e) => handlePropsChange("insta", e.target.value)} />

        <Checkbox
          checked={values.qr_code_insta}
          onChange={(e) => {
            handlePropsChange("qr_code_insta", e.target.checked);
            if (values.qr_code_website)
              handlePropsChange("qr_code_website", false);
          }}
        >
          {t("Instagram as QR")}
        </Checkbox>
        <Checkbox
          style={{ margin: 0 }}
          checked={values.qr_code_website}
          onChange={(e) => {
            handlePropsChange("qr_code_website", e.target.checked);
            if (values.qr_code_insta) handlePropsChange("qr_code_insta", false);
          }}
        >
          {t("Website as QR")}
        </Checkbox>
      </div>
    </Modal>
  );
}

export default withNamespaces()(PrintCountModal);
